export default {
  drawPoiMarker (map, id, position, cssClass) {
    let elem = '<div class="poi-marker {CSS_CLASS}"></div>'
    elem = elem.replace('{CSS_CLASS}', cssClass)
    let icon = new window.H.map.DomIcon(elem)
    let pin = new window.H.map.DomMarker(position, { icon: icon, zIndex: 1 })
    pin.id = id
    map.addObject(pin)
  },
  drawCar (map, driver) {
    let elem = '<div class="car-marker" style="background-position: -' + (driver.heading * 45) + 'px"></div>'
    let icon = new window.H.map.DomIcon(elem)
    let pin = new window.H.map.DomMarker(driver, { icon: icon, zIndex: 2 })
    pin.id = 'car_marker_' + driver.provContactId
    map.addObject(pin)
  },
  removeCarMarkers (map) {
    if (map === null) {
      return
    }

    map.getObjects().forEach(object => {
      if (object.id.indexOf('car_marker_') >= 0) {
        map.removeObject(object)
      }
    })
  },
  drawPickupLabel (map, id, driverEta, pickup, position) {
    let elem = '<div class="H_bubbles pickup-info info {CSS_POSITION}">' +
          '<img src="https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/marker-eta.png" />' +
          '<div class="left"><span class="value">{ETA_VALUE}</span><span class="label">{ETA_LABEL}</span></div>' +
          '<div class="right"><span class="label">PICK-UP</span><span class="value">{PICKUP_TITLE}</span></div>' +
          '</div>'

    let eta = Math.round(driverEta / 60)
    if (eta <= 0) {
      eta = 1
    }
    let etaLabel = 'mins'
    if (eta <= 1) {
      etaLabel = 'min'
    }
    elem = elem.replace('{CSS_POSITION}', position)
    elem = elem.replace('{ETA_VALUE}', eta)
    elem = elem.replace('{ETA_LABEL}', etaLabel)
    elem = elem.replace('{PICKUP_TITLE}', pickup.title)

    let icon = new window.H.map.DomIcon(elem)
    let pin = new window.H.map.DomMarker(pickup, { icon: icon, zIndex: 3 })
    pin.id = id
    map.addObject(pin)
  },
  drawDropoffLabel (map, id, eta, dropoff, position) {
    let elem = '<div class="H_bubbles dropoff-info info {CSS_POSITION}">' +
          '<img src="https://s3-us-west-2.amazonaws.com/mobile-consumer-app/maps/pins/marker-arrival.png" />' +
          '<div class="left"><span class="value">{ETA_VALUE}</span><span class="label">{ETA_LABEL}</span></div>' +
          '<div class="right"><span class="label">DROP-OFF</span><span class="value">{PICKUP_TITLE}</span></div>' +
          '</div>'
    elem = elem.replace('{CSS_POSITION}', position)
    elem = elem.replace('{ETA_VALUE}', eta.format('hh:mm'))
    elem = elem.replace('{ETA_LABEL}', 'ETA/' + eta.format('A'))
    elem = elem.replace('{PICKUP_TITLE}', dropoff.title)
    let icon = new window.H.map.DomIcon(elem)
    let pin = new window.H.map.DomMarker(dropoff, { icon: icon, zIndex: 3 })
    pin.id = id
    map.addObject(pin)
  },
  drawTerminalMarkers (map, id, pins) {
    let elem = '<div class="poi-marker terminal"></div>'
    let icon = new window.H.map.DomIcon(elem)
    let items = []
    for (let i = 0; i < pins.length; i++) {
      let position = pins[i]
      let pin = new window.H.map.DomMarker({lat: position.lat, lng: position.lng}, { icon: icon, zIndex: 1 })
      items.push(pin)
    }
    let group = new window.H.map.Group()
    group.addObjects(items)
    group.id = id
    map.addObject(group)
  },
  drawPickupArea (map, id, points) {
    let lineString = new window.H.geo.LineString()
    points.forEach(function (point) {
      lineString.pushLatLngAlt(point.lat, point.lng)
    })

    let polyline = new window.H.map.Polygon(lineString, {
      style: {
        lineWidth: 1,
        strokeColor: 'rgba(142,185,56,1)',
        fillColor: 'rgba(142,185,56,0.5)'
      }
    })
    polyline.id = id
    map.addObject(polyline)
  },
  drawLaxItTerminals (map, id, terminals) {
    if (map === null) {
      return
    }
    let items = []
    for (let i = 0; i < terminals.length; i++) {
      let terminal = terminals[i]
      let elem = '<div class="terminal-marker">' + terminal.label + '</div>'
      let icon = new window.H.map.DomIcon(elem)
      let pin = new window.H.map.DomMarker(terminal.coords, { icon: icon, zIndex: 1 })
      items.push(pin)
    }
    let group = new window.H.map.Group()
    group.addObjects(items)
    group.id = id
    map.addObject(group)
  }
}



// WEBPACK FOOTER //
// ./src/components/Runs/_map-marker-utils.js